export default "__VITE_ASSET__C9NTLpt0__"